import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createBookTimeFrameValidationSchema = Yup.object().shape({
  startTime: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  endTime: Yup.string()
    .required(SystemMessage.INPUT_REQUIRED)
    .test(
      "startTime-endTime",
      "Giờ kết thúc phải lớn hơn giờ bắt đầu",
      function (value) {
        const { startTime } = this.parent;

        return startTime && value
          ? value > startTime
          : true;
      }
    ),
  bookIds: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
